import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useGetRequest } from '../../../../hooks/useGetRequest';
import SignatureImageView from './signatureImageView';
import { deleteConfirmation } from '../../../../utils/helpers';
import { useDeleteRequest } from '../../../../hooks/useDeleteRequest';

const lineStyleMap = {
  dotted: '2px dotted #000',
  solid: '1px solid #000',
  dashed: '1px dashed #000',
};

const SignatureView = ({
  element,
  isPad,
  prescriptionSetting,
  isPrescription = false,
}) => {
  const userInfo = useSelector((state) => state.authReducer.data);
  const [imageContent, setImageContent] = useState('');
  const { doctorName } = userInfo;

  const { isLoading: isGetImageLoading, refetch: getImageLoad } = useGetRequest(
    `getSignatureContent-${userInfo.id}`,
    `doctors/signature-content/${userInfo.id}`,
    (data) => {
      setImageContent(data);
    },
    (e) => {
      console.log(e);
    },
  );

  const { isLoading: isLoading, mutate: deleteSignature } = useDeleteRequest(
    `doctors/delete-signature/${userInfo.id}`,
    (data) => {
      setImageContent('');
    },
    (e) => {
      console.log(e);
    },
  );

  useEffect(() => {
    getImageLoad();
  }, []);

  const signatureStyle = () => {
    const qty = prescriptionSetting?.footer?.height?.quantity;
    const unit = prescriptionSetting?.footer?.height?.unit;
    const bottom = qty && unit ? `${qty}${unit}` : '30px';
    return {
      bottom,
      right: '25px',
    };
  };

  return (
    <div
      className={`${isPrescription ? 'prescription-signature-view' : ''} ${
        userInfo?.signaturePosition && isPad ? 'signature-fixed' : ''
      }`}
      style={userInfo?.signaturePosition && isPad ? signatureStyle() : {}}
    >
      <div>
        {imageContent && (
          <SignatureImageView
            signature={imageContent}
            height={80}
            width={280}
          />
        )}
        {!isPrescription && imageContent && (
          <i
            className="far fa-times-circle ml-3"
            style={{ fontSize: '18px' }}
            onClick={() => deleteConfirmation(deleteSignature, 23)}
          ></i>
        )}
      </div>
      {isPrescription && doctorName && (
        <div
          className="text-center mt-2"
          style={
            lineStyleMap[element?.signatureLine]
              ? { borderTop: lineStyleMap[element.signatureLine], paddingTop: '3px' }
              : {}
          }
        >
          {doctorName}
        </div>
      )}
    </div>
  );
};

export default memo(SignatureView);
